; (function (window, document) {

	'use strict'

	let simpleFilter = document.getElementById('simple-filter')
	let itemsToFilter = document.querySelectorAll('.item-to-filter')

	// gets the data-target from options in a select input called "simple-filer"
	//console.log(simpleFilter)
	if (simpleFilter && itemsToFilter) {
		simpleFilter.addEventListener('change', function () {
			console.log('You selected: ', this.value);
			filterItems(this.value)
		});
	}

	// filter objects
	function filterItems(target = false) {

		//console.log(target)
		//console.log(itemsToFilter)

		if (target) {
			[].forEach.call(itemsToFilter, function (item) {

				if ('all' === target) {
					item.classList.remove('filtered')
				} else if (item.dataset.id.includes(target)) {
					console.log('we have a match')
					item.classList.remove('filtered')
				} else {
					item.classList.add('filtered')
				}
			});
		}
	}

})(window, document)